// extracted by mini-css-extract-plugin
export default {"wrapper":"v1-z","play":"w1-z"};